import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/home";
import about from "./about/index";
import service from "./service/index";
import programme from "./programme/index";
import mobile from "./mobile/index";
//引入rem函数
import remSet from "@/assets/js/rem.js";
Vue.use(Router);
let witchHome = "/home";
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  //移动端
  witchHome = "/mobile/home";
}
let constantRouterMap = [];

//pc端
if (witchHome === "/home") {
  constantRouterMap = [
    {
      path: "/home",
      name: "home",
      component: Home,
      title: "首页"
    },
    service,
    programme,
    {
      path: "/businessCooperation",
      name: "businessCooperation",
      component: () => import("@/views/businessCooperation"),
      title: "商务合作"
    },
    about,
    {
      path: "/",
      redirect: witchHome,
      hidden: true
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/views/login/register"),
      hidden: true
    }
  ];
}
//移动端
if (witchHome === "/mobile/home") {
  remSet();
  constantRouterMap = [
    {
      path: "*",
      redirect: witchHome,
      hidden: true
    },
    mobile
  ];
}
export default new Router({
  // mode: "history",
  // 需要再nginx配置
  // location / {
  //   try_files $uri $uri/ /index.html;
  // }
  mode: "hash",
  base: process.env.BASE_URL,
  routes: constantRouterMap
});
